import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { PersonalCreditReport } from 'app/models/dto/credit-reports/personal-credit-report.model';
import { CreditReportsService } from 'app/services/credit-reports/credit-reports.service';
import { GetPersonalCreditReport } from './credit-reports.actions';
import { take, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export class CreditReportsStateModel {
  personalCreditReport: PersonalCreditReport;
  error: string;
}

@State<CreditReportsStateModel>({
  name: 'creditReport'
})

@Injectable()

export class CreditReportsState {
  @Selector()
  static personalCreditReport(state: CreditReportsStateModel) {
    return state.personalCreditReport;
  }

  @Selector()
  static error(state: CreditReportsStateModel) {
    return state.error;
  }

  constructor(
    private creditReportService: CreditReportsService
  ){}

  @Action(GetPersonalCreditReport)
  getCreditReport({patchState}: StateContext<CreditReportsStateModel>, {borrowerId}: GetPersonalCreditReport) {
    this.creditReportService.getPersonalCreditReport(borrowerId)
      .pipe(take(1), catchError( error => {
        patchState({ error });
          return of();
      }))
      .subscribe((personalCreditReport: PersonalCreditReport) => {
        patchState({
          personalCreditReport: personalCreditReport
        });
      });
  }
}

